import BigNumber from 'bignumber.js'
import boostPools from 'config/constants/boostPools'
import { getCraftsmanContract, getVvsBoostContract } from 'utils/contractHelpers'
import { ChainId } from 'vvs-sdk'

const vvsBoostContract = getVvsBoostContract()
const craftsmanContract = getCraftsmanContract()

const pid = process.env.REACT_APP_CHAIN_ID === ChainId.MAINNET.toString() ? 23 : 27

export const fetchVvsBoostPoolData = async () => {
  const [totalSupply, totalAllocPoint, info, ...boostPoolinfo] = await Promise.all([
    vvsBoostContract.totalSupply(),
    craftsmanContract.totalAllocPoint(),
    craftsmanContract.poolInfo(pid),
    ...boostPools.map((pool) => vvsBoostContract.poolInfo(pool.pid)),
  ])

  const formattedPoolInfo = boostPoolinfo.map((pool, i) => ({
    poolId: i,
    stakes: new BigNumber(pool.totalStaked._hex).toJSON(),
  }))

  return [
    new BigNumber(totalSupply._hex).toJSON(),
    new BigNumber(info.allocPoint._hex).div(new BigNumber(totalAllocPoint._hex)).toJSON(),
    ...formattedPoolInfo,
  ]
}
